import { DefaultQueryParams, EnvironmentTypes, parseQuery } from '@pascal/pascal-core';
import { TURBO_GAME_ID } from './constants';

const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const isTurbo = +gameId === TURBO_GAME_ID;

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID:
    // eslint-disable-next-line no-nested-ternary
    process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 47 : isTurbo ? 69 : 30,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
